import React, { useEffect, useState } from 'react';
import {
  Typography,
  TextField,
  Button,
  Box,
  Snackbar,
  Alert
} from '@mui/material';
import { getDecryptedAccessToken, getDecryptedData, getDecryptedUserType } from '../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../../Utils/ApiServices/ApiServices';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const MembershipSubscribeForm = ({ plan, onClose }) => {
  const accessToken = getDecryptedAccessToken();
  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();
  const params = useParams();
  const navigate = useNavigate();
  const [groupName, setGroupName] = useState('');
  const [patientDetails, setPatientDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const pid = LoginUserType === 'Patient' ? LoginUserDetails?.pid : params?.pid;
  const uuid = LoginUserType === 'Patient' ? LoginUserDetails?.uuid : params?.uuid;

  useEffect(() => {
    const fetchPatient = async () => {
      try {
        const response = await ApiServices.get(`/apis/default/api/patient/${uuid}`, {
          Authorization: `Bearer ${accessToken}`
        });

        setPatientDetails(response.data);

        if (plan.category === 'family') {
          setGroupName(`${response.data.data.fname} ${response.data.data.lname} Family Plan`);
        } else if (plan.category === 'business') {
          setGroupName(''); // Allow user to enter
        } else {
          setGroupName(`${response.data.data.fname} ${response.data.data.lname} Personal Plan`);
        }
      } catch (error) {
        console.error("Error fetching patient details", error);
      }
    };

    fetchPatient();
  }, [params.uuid, plan.category, accessToken]);

  const handleSubmit = async () => {
    if (!groupName.trim()) {
      setSnackbar({ open: true, message: 'Group name is required.', severity: 'warning' });
      return;
    }

    try {
      setLoading(true);
      await ApiServices.post(`/apis/default/api/membership/patient/${pid}`, {
        plan_id: plan.id,
        group_type: plan.category || 'single',
        group_name: groupName,
        validity_months: 12,
        status: "approved"
      }, {
        Authorization: `Bearer ${accessToken}`
      });

      setSnackbar({ open: true, message: 'Subscribed successfully!', severity: 'success' });
      setTimeout(() => {
        onClose();
        navigate(-1);
      }, 1000);
    } catch (error) {
      console.error('Subscription error:', error);
      setSnackbar({ open: true, message: 'Failed to subscribe.', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };



  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        You are about to subscribe to the <strong>{plan.type_name}</strong> plan. Please confirm the details below.
      </Alert>

      <Typography variant="subtitle1" gutterBottom>
        <strong>Plan Tier:</strong> {plan.plan_tier}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        <strong>Plan Name:</strong> {plan.type_name}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        <strong>Group Type:</strong> {plan.category || 'Single'}
      </Typography>

      {(plan.category === 'business') && (
        <TextField
          label="Business Group Name"
          fullWidth
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          margin="normal"
        />
      )}

      {(plan.category !== 'business') && (
        <TextField
          label="Group Name"
          fullWidth
          value={groupName}
          disabled
          margin="normal"
        />
      )}


      <Box textAlign="right" mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Subscribe'}
        </Button>
      </Box>

     

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default MembershipSubscribeForm;
